import { RegisterComponent } from '../../ecs/Component';
import { AxesHelper } from '../../thirdparty/three/imports';
import { Component3D } from '../core/Component3D';

declare module '../../ecs/Component'
{
    interface ComponentMap { AxesHelper3D: AxesHelper3D; }
}

/**
 * 包装`three`中`AxesHelper`。
 */
@RegisterComponent({ name: 'AxesHelper3D' })
export class AxesHelper3D extends Component3D
{
    _helper: AxesHelper;

    size?: number;

    init()
    {
        super.init();
        this._helper = new AxesHelper(this.size);

        this._entity._group.add(this._helper);
    }

    destroy(): void
    {
        this._entity._group.remove(this._helper);

        this._helper.dispose();
        this._helper = null;

        super.destroy();
    }
}
